import React from 'react'
import './imageBlobBackground.scss'

interface ImageBlobBackgroundProps {
    blobImage: string;
    image: string;
}

const ImageBlobBackground = ({ blobImage, image }: ImageBlobBackgroundProps) => {
    return (
        <div className="blob-images">
            <img src={blobImage} alt="" className="blob-images__blob" />
            <img src={image} alt="Alerta" className="blob-images__alert" />
        </div>
    )
}

export default ImageBlobBackground